const encodeString = (value) => {
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(value);
  }
  
  // Basic fallback encoding (not UTF-8 safe but keeps deterministic behavior)
  const arr = new Uint8Array(value.length);
  for (let i = 0; i < value.length; i++) {
    arr[i] = value.charCodeAt(i);
  }
  return arr;
};

const bufferToHex = (buffer) => {
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

/**
 * Deterministically hash the supplied credentials for offline use.
 * Uses SHA-256 via Web Crypto when available, falls back to a simple
 * base64 string so that offline login continues to work on older browsers.
 */
export const hashPassword = async (email, password) => {
  const normalizedEmail = (email || '').trim().toLowerCase();
  const combined = `${normalizedEmail}::${password || ''}`;
  const data = encodeString(combined);
  
  if (typeof window !== 'undefined' && window.crypto?.subtle) {
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    return bufferToHex(hashBuffer);
  }
  
  // Fallback: convert to base64 string (less secure but better than plaintext)
  let binary = '';
  const bytes = new Uint8Array(data);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  
  return btoa(binary);
};

export default hashPassword;


